module.exports = __webpack_public_path__ + "static/media/gtech.e5cb1381.png";